import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { sanitizeHtml } from '@shared/utils/editor-utils';

import { QuizInstanceApiModel } from '@app/api/api-models/quiz-instance/QuizInstanceApiModel';
import { InitializeQuizApiModel } from '@app/api/api-models/quiz-instance/InitializeQuizApiModel';
import { ProcessQuizStepApiModel } from '@app/api/api-models/quiz-instance/ProcessQuizStepApiModel';
import { ProcessQuizStepResultApiModel } from '@app/api/api-models/quiz-instance/ProcessQuizStepResultApiModel';
import { SaveAnswerApiModel } from '@app/api/api-models/quiz-instance/SaveAnswerApiModel';
import { UserListApiModel } from '@app/api/api-models/users/UserListApiModel';
import { FormInstanceCollectionDeleteResultApiModel, InitializedQuizApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class QuizInstancesService {
  public apiUrl = 'quiz-instances';

  constructor(private readonly http: HttpClientService) {}

  public getInitialized(id: number): Observable<InitializedQuizApiModel> {
    return this.http.get<InitializedQuizApiModel>(`${this.apiUrl}/get-initialized/${id}`);
  }

  public getById(id: number): Observable<QuizInstanceApiModel> {
    return this.http.get<QuizInstanceApiModel>(`${this.apiUrl}/get/${id}`);
  }

  public getNextUsers(id: number): Observable<Array<UserListApiModel>> {
    return this.http.get<Array<UserListApiModel>>(`${this.apiUrl}/${id}/next-users`);
  }

  public initialize(model: InitializeQuizApiModel): Observable<Object> {
    return this.http.post(`${this.apiUrl}/initialize`, model);
  }

  public delete(id: number): Observable<object> {
    return this.http.delete(`${this.apiUrl}/delete/${id}`);
  }

  public deleteMultiple(ids: Array<number>): Observable<FormInstanceCollectionDeleteResultApiModel> {
    let queryParams = new HttpParams();
    queryParams = queryParams.appendAll({ ids: ids });

    return this.http.delete(`${this.apiUrl}/delete-multiple`, { params: queryParams });
  }

  public processStep(model: ProcessQuizStepApiModel): Observable<ProcessQuizStepResultApiModel> {
    model.Comment = sanitizeHtml(model.Comment);
    return this.http.put<ProcessQuizStepResultApiModel>(`${this.apiUrl}/process-step`, model);
  }

  public saveAnswer(model: SaveAnswerApiModel): Observable<Object> {
    return this.http.put(`${this.apiUrl}/save-answer`, model);
  }

  public getPdf(id: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/pdf`, { responseType: 'blob' });
  }
}
